import SelectionState from 'state/selections/SelectionState';
import React from 'react';
import {useBetaDecodesQuery as useBetaDecodesQuery_} from '@ls/entity-mapping-service';
import {selectDefinitions} from 'state/betas/selectors';
import {useSelector} from 'react-redux';

import {titleCase} from '@ls/js-utils';
export const useBetaDecodesQuery = () => {
    const query = useBetaDecodesQuery_();
    return React.useMemo(() => {
      const newQuery = {...query};
      if (newQuery.data) {
        const betas = query.data;
        const betasByBetaId = betas.reduce((map, beta) => {
          map[beta.betaId] = beta;
          return map;
        }, {});
  
        const betaOptions = betas.map(({betaId, betaName}) => ({label: `${betaName} (${betaId})`, value: betaId}));
        const betaOptionsByBetaId = betaOptions.reduce((map, betaOption) => {
          map[betaOption.value] = betaOption;
          return map;
        }, {});
  
        newQuery.data = {
          betas,
          betasByBetaId,
          betaOptions,
          betaOptionsByBetaId,
        };
      }
      return newQuery
    }, [query]);
  };
  
  export const useBetaColumnDefinitions = () => {
    const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
    const {data} = useBetaDecodesQuery();
    const betasByBetaId = data?.betasByBetaId;
    return React.useMemo(() => {
      return definitions.reduce((columnDefs, {betaId, covarianceType, key, scaleType}) => {
        const betaEntity = betasByBetaId?.[betaId];
        const headerName = `${betaEntity?.betaName ?? ''} (${betaId}) - ${covarianceType === 'Historical' ? 'HIST' : 'SHORT'} , ${titleCase(scaleType)}`
       
          columnDefs.push({
            headerName: `${headerName}`,
            field: key,
            colId: key,
           
          });
        
        return columnDefs;
      }, []);
    }, [betasByBetaId, definitions]);
  
  }